import { render } from "./App.vue?vue&type=template&id=67fe7e50"
const script = {}

import exportComponent from "E:\\work\\code\\ai-view\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__